import React from 'react'
import IconBreadcrumbChevron from '@/components/icons/IconBreadcrumbChevron/IconBreadcrumbChevron'
import computeBreadCrumbs from '../../../domain/useCases/computeBreadCrumbs'
import { isNonEmptyString } from '../../../utils/checks'

const BreadCrumbV2 = ({
  pageType = '',
  shouldDefaultRegionalize = false,
  center = null,
  location = null,
  term = null
}) => {
  const allCentersText = `All ${
    shouldDefaultRegionalize ? 'Centres' : 'Centers'
  }`

  const { breadCrumbs, selectedTitle } = computeBreadCrumbs({
    center,
    location,
    pageType,
    term,
    isV2: true
  })

  return (
    <div className="w-full">
      <div className="hide-scroll -mx-4 flex items-center overflow-x-auto whitespace-nowrap px-4 text-xs font-medium md:mx-0 md:px-0">
        <a
          href="/"
          className="rounded-md px-1 py-0.5 text-xs font-medium text-gray-900 hover:bg-white/70 active:bg-white/90"
          data-text="All Centers"
        >
          {allCentersText}
        </a>
        <IconBreadcrumbChevron className="mx-0.5 shrink-0 text-gray-900" />
        {breadCrumbs.map((item) => (
          <div
            key={item.slug}
            className="flex items-center justify-between"
          >
            {isNonEmptyString(item.slug) ? (
              <a
                className="rounded-md px-1 py-0.5 text-xs text-gray-900 hover:bg-white/70 active:bg-white/90"
                href={`/${item.slug}/`}
              >
                {item.title}
              </a>
            ) : (
              <span className="rounded-md px-1 py-0.5 text-xs text-gray-900 hover:bg-white/70 active:bg-white/90">
                {item.title}
              </span>
            )}
            <IconBreadcrumbChevron className="mx-0.5 shrink-0 text-gray-900" />
          </div>
        ))}
        <span className="px-1 py-0.5 text-xs font-semibold text-gray-1100">
          {selectedTitle}
        </span>
      </div>
    </div>
  )
}

export default BreadCrumbV2
